import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { MinimalCurvatureParams } from '@core/core/types'
import { SingleInput } from '@library/model'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import { extrapolationMethods, interpolationMethods, weightCoefficients } from '../constants'
import css from '../MapBuildingRightMenu.css'
import type {
  ExtrapolationMethodItemsType,
  InterpolationMethodItemsType,
  MinimalCurvatureAlgorithmMenuProps,
  WeightCoefficientItemsType,
} from '../types'

export const MinimalCurvatureAlgorithmMenu: FC<MinimalCurvatureAlgorithmMenuProps> = ({
  formData,
  updateMinimalCurvatureData,
}) => {
  const onInterpolationMethodChange = (value: Nullable<InterpolationMethodItemsType>) => {
    if (value) {
      updateMinimalCurvatureData(prev => {
        if (prev) {
          return { ...prev, interpolationMethod: value.key }
        }
      })
    }
  }

  const onWeightCoefficientChange = (value: Nullable<WeightCoefficientItemsType>) => {
    if (value) {
      updateMinimalCurvatureData(prev => {
        if (prev) {
          return { ...prev, weightCoefficient: value.key }
        }
      })
    }
  }

  const onExtrapolationMethodChange = (value: Nullable<ExtrapolationMethodItemsType>) => {
    if (value) {
      updateMinimalCurvatureData(prev => {
        if (prev) {
          return { ...prev, extrapolationMethod: value.key }
        }
      })
    }
  }

  const onParamChange = (key: keyof MinimalCurvatureParams) => (value: Nullable<string>) => {
    updateMinimalCurvatureData(prev => {
      if (prev) {
        return { ...prev, [key]: value ? Number(value) : null }
      }
    })
  }

  return (
    <>
      <Select
        label="Метод интерполяции"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={interpolationMethods}
        value={
          formData.minimalCurvature?.interpolationMethod === 'MeanValue'
            ? interpolationMethods[0]
            : null
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onInterpolationMethodChange}
      />
      <Select
        label="Весовой коэффициент"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={weightCoefficients}
        value={
          formData.minimalCurvature?.weightCoefficient === 'Equals' ? weightCoefficients[0] : null
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onWeightCoefficientChange}
      />
      <Select
        label="Метод экстраполяции"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={extrapolationMethods}
        value={
          formData.minimalCurvature?.extrapolationMethod === 'MinimalCurvature'
            ? extrapolationMethods[0]
            : null
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onExtrapolationMethodChange}
      />
      <div className={css.rowMenuFields}>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Максимальная невязка
          </Text>
          <SingleInput
            value={formData.minimalCurvature?.maxDiscrepancy}
            withClearButton={true}
            min={0.00001}
            className={css.validatedTextFields}
            onChange={onParamChange('maxDiscrepancy')}
          />
        </div>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Количество итераций
          </Text>
          <SingleInput
            value={formData.minimalCurvature?.iterationsCount}
            mode="integer"
            withClearButton={true}
            min={1}
            className={css.validatedTextFields}
            onChange={onParamChange('iterationsCount')}
          />
        </div>
      </div>
    </>
  )
}
